import { TableTypes } from '@/constant';
import { useGetListData, useRowSelection } from '@/hooks';
import { ContractedForeignBusinessActions } from '@/stores';
import { MyPageSelectors } from '@/stores/my-page';
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { DefaultOptionType } from 'antd/es/select';

import { getColumns } from './config';
import { IProps } from './type';

export const useLogic = (props: IProps) => {
	const { id, canEdit = false } = props;
	const { t } = useTranslation('common');
	const { isSystemRole } = useSelector(MyPageSelectors.selectDataMyPage);

	const dispatch = useDispatch();
	const rowSelection = useRowSelection();

	const { params: reduxParams, total } = useGetListData({
		type: TableTypes.CONTRACTED_FOREIGN_BUSINESS,
	});

	const fetchData = useCallback(
		(params?: Partial<typeof reduxParams>) => {
			if (!id) {
				return;
			}
			dispatch(
				ContractedForeignBusinessActions.getContractedForeignBusinessListRequest(
					{
						id,
						page: params?.page || reduxParams.page,
						pageSize: params?.pageSize || reduxParams.pageSize,
					}
				)
			);
		},
		[id, dispatch, reduxParams]
	);

	const columns = useMemo(() => {
		return getColumns(t, isSystemRole, fetchData);
	}, [t, isSystemRole, fetchData]);

	useEffect(() => {
		fetchData();
	}, [id]);

	const handlePageChange = useCallback(
		(page: number) => {
			fetchData({
				page,
			});
		},
		[fetchData]
	);

	const handlePageSizeChange = useCallback(
		(pageSize: DefaultOptionType['value']) => {
			fetchData({
				page: 1,
				pageSize: Number(pageSize),
			});
		},
		[fetchData]
	);

	return {
		columns,
		rowSelection,
		fetchData,
		canEdit,
		handlePageChange,
		handlePageSizeChange,
		reduxParams,
		total,
	};
};
